import { lazy } from "react";
import CreatePassword from "../pages/createPassword";
import Logout from '../pages/logout';
import LoginChallenge from "../pages/login-challenge";
import SocialAuthCallback from "../pages/socialAuthCallback";
import { APPLE_PROVIDER, GOOGLE_PROVIDER } from "../config/socialProviders";
const Login = lazy(() => import('../pages/login'));
const ForgotPassword = lazy(() => import('../pages/forgotPassword'));

export const AuthRoutes  = [
    {
        path: 'logout',
        element: <Logout />
    },
    {
        path: "login",
        element: <Login />
    },
    {
        path: "login-desafio-60-dias",
        element: <LoginChallenge origin="/ao-vivo/desafio-60-dias" />
    },
    {
        path: "login/statera",
        element: <Login companyName="statera" />
    },
    {
        path: "callback-google",
        element: <SocialAuthCallback provider={GOOGLE_PROVIDER} />
    },
    {
        path: "callback-apple",
        element: <SocialAuthCallback provider={APPLE_PROVIDER} />
    },
    {
        path: "confirma-conta/:token",
        element: <CreatePassword />
    },
    {
        path: "recuperar-senha",
        element: <ForgotPassword />
    }
]
